module.exports = __webpack_public_path__ + "static/favicon-512-9f2f85db7ce4949395f6bc2143b7cbd2.png";